import React, { useState } from 'react'
import { Button, Typography } from '@material-ui/core'
import DialogUpgradeOffice from './DialogUpgradeOffice'

const HomeUnlockPreferredPricing = ({ officeId }) => {
  const [showDialog, setShowDialog] = useState(false)

  const handleOpen = () => {
    setShowDialog(true)
  }

  const handleClose = (_, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return
    }
    setShowDialog(false)
  }
  return (
    <>
      <Typography component="p" gutterBottom variant="body1">
        Access special offers and features for everyone at your office!
      </Typography>
      <Button onClick={handleOpen} color="primary" variant="contained" style={{ width: '12rem' }}>
        Complete Setup
      </Button>
      <DialogUpgradeOffice showDialog={showDialog} closeDialog={handleClose} officeId={officeId} />
    </>
  )
}

export default HomeUnlockPreferredPricing
